export const FORCE_COMPLETE_CONFIRM_MESSAGE =
  "All the cartons are not diverted/ palletised, do you still want to complete?";

/** Spur rows that have at least one assigned pallet group. */
export function getSpursEligibleForComplete(spurRows) {
  return (spurRows || []).filter((row) => (row.palletGroupCount || 0) > 0);
}

/** True when diverted/palletised counts do not all match total cartons (force complete path). */
export function spurRequiresForceCompleteConfirm(spurRow) {
  if (!spurRow || (spurRow.palletGroupCount || 0) <= 0) {
    return false;
  }
  return !spurRow.readyToComplete;
}

export function selectedSpursNeedForceCompleteConfirm(spurRows) {
  return getSpursEligibleForComplete(spurRows).some(spurRequiresForceCompleteConfirm);
}
